export const formatDate = (dt: Date): string => {
  return dt.toLocaleDateString();
};
